export const OutbreakShareURL = 'https://metadefender.opswat.com/reports/outbreak';
export const MarketShareURL = 'https://metadefender.opswat.com/reports/anti-malware-market-share';
